import { ColumnDef } from "@tanstack/react-table";
import { useEffect, useState } from "react";
import api from "../../api/axios";
import { DataTable } from "../data-table/data-table";

export function AddCustomer() {

    const [name, setName] = useState<string>("");
    const [managerEmail, setManagerEmail] = useState<string>("");
    const [licenses, setLicenses] = useState<number>(0);

    const [course6, setCourse6] = useState<boolean>(true); // NEW Grundlagenschulung KI-Kompetenzen
    const [course7, setCourse7] = useState<boolean>(true); // NEW 9 Grundsätze für einen verantwortungsbewussten KI-Einsatz
    const [course8, setCourse8] = useState<boolean>(true); // NEW Microsoft Copilot
    const [course9, setCourse9] = useState<boolean>(false); // HWK Grundlagenschulung KI-Kompetenzen
    const [course10, setCourse10] = useState<boolean>(false); // NEW Fundamentals Training in AI Competencies

    const addCustomer = async () => {
        try {
            const response = await api.post('/add-customer', {
                name,
                managerEmail,
                licenses,
                courses: {
                    course6, // NEW Grundlagenschulung KI-Kompetenzen
                    course7, // NEW 9 Grundsätze für einen verantwortungsbewussten KI-Einsatz
                    course8, // NEW Microsoft Copilot
                    course9,  // HWK Grundlagenschulung KI-Kompetenzen
                    course10 // NEW Fundamentals Training in AI Competencies
                }
            });

            if (response.status === 200) {
                alert("Customer added successfully!");
                // Reset form fields
                setName("");
                setManagerEmail("");
                setLicenses(0);
                setCourse6(true);
                setCourse7(true);
                setCourse8(true);
                setCourse9(true);
                setCourse10(true);
            } else {
                alert("Failed to add customer.");
            }
        } catch (error) {
            console.error("Error adding customer:", error);
            alert("An error occurred while adding the customer.");
        }
    }

    return (
        <div className="add-customer">
            <h4>Neukundenanlage</h4>
            <h4>Name</h4>
            <input
                className="text-input"
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Kundenname eingeben"
            />
            <h4>Manager-Email</h4>
            <input
                className="text-input"
                type="text"
                value={managerEmail}
                onChange={(e) => setManagerEmail(e.target.value)}
                placeholder="Manager-Email eingeben"
            />
            <h4>Lizenzen</h4>
            <input
                className="number-input"
                type="number"
                value={licenses}
                onChange={(e) => setLicenses(Number(e.target.value))}
                placeholder="Anzahl der Lizenzen eingeben"
            />
            <h4>Kurse</h4>
            <div>
                <input className="course-checkbox" type="checkbox" id="course6" checked={course6} onChange={(e) => setCourse6(e.target.checked)} />
                <label htmlFor="course6">NEW Grundlagenschulung KI-Kompetenzen</label>
            </div>
            <div>
                <input className="course-checkbox" type="checkbox" id="course7" checked={course7} onChange={(e) => setCourse7(e.target.checked)} />
                <label htmlFor="course7">NEW 9 Grundsätze für einen verantwortungsbewussten KI-Einsatz</label>
            </div>
            <div>
                <input className="course-checkbox" type="checkbox" id="course8" checked={course8} onChange={(e) => setCourse8(e.target.checked)} />
                <label htmlFor="course8">NEW Microsoft Copilot</label>
            </div>
            <div>
                <input className="course-checkbox" type="checkbox" id="course9" checked={course9} onChange={(e) => setCourse9(e.target.checked)} />
                <label htmlFor="course9">HWK Grundlagenschulung KI-Kompetenzen</label>
            </div>
            <div>
                <input className="course-checkbox" type="checkbox" id="course10" checked={course10} onChange={(e) => setCourse10(e.target.checked)} />
                <label htmlFor="course10">NEW Fundamentals Training in AI Competencies</label>
            </div>
            <div>
                <button className="button button-primary" onClick={() => addCustomer()}>Kunde hinzufügen</button>
            </div>

        </div>
    );
}